const de = {
    controlsTitle: "Was suchen Sie?",
    roomApartment: "Wohnung mit FLATSIZE Zimmern",
    room: "Zimmer",
    budgetUpTo: "Budget bis",
    offers:"Angebote",
    areRoomApartments: "Wohnungen mit FLATSIZE Zimmern",
    areInBudgetOf: "sind im Budget von",
    areNotInBudget: "sind nicht im Budget",
    inBudget: "sind im Budget",
    fewOffers: "Weniger als 50 Angebote",
    bfsIdParamName: "gemeinde",
}
const fr = {
    controlsTitle: "Que cherchez-vous?",
    roomApartment: "Appartement avec FLATSIZE pièces",
    room: "chambre",
    budgetUpTo: "Budget jusqu'à",
    offers:"offres",
    areRoomApartments: "appartements de FLATSIZE pièces",
    areInBudgetOf: "sont dans le budget de",
    areNotInBudget: "ne sont pas dans le budget",
    inBudget: "sont dans les budget",
    fewOffers: "Moins de 50 offres",
    bfsIdParamName: "commune",
}
export { de, fr }